/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { forwardRef } from "react";
import Button from "@mui/material/Button";

const ButtonLargePrimary = forwardRef((props, ref) => {

    const commonProps = {
        className: `  ${props.className ? props.className : ""}`,
        variant: "contained",
        color: "primary",
        size: "large",
    };

    //  Combine ClassName from "default" and "props"
    const asArray = Object.entries(props);
    const filtered = asArray.filter(([key]) => key !== "className");
    const propsFilter = Object.fromEntries(filtered);

    const allProps = {
        ...commonProps,
        ...propsFilter,
    };

    return (
        <Button ref={ref} {...allProps}>
            {allProps.label}
        </Button>
    );
});

ButtonLargePrimary.displayName = "ButtonLargePrimary";

export { ButtonLargePrimary };
